import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../components/Header'
import hero from '../images/contact__hero.jpg'
import './contact.styl'

import ContactForm from '../components/Forms/ContactForm';

const Page = () => (
  <Fragment>
    <Helmet
      title="Contact"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Contact</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__content">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/contact" activeClassName="is-active">
                Contact
              </Link>
            </li>
          </ul>
          <ContactForm source="contact"/>
          
              
              
            </div>
          </div>

    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/contact.js